import { OfflineDatabaseModule } from './database/offline-database.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { AuthRoutingModule } from './auth/auth-routing.module';
import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule } from './auth/auth.module';
import { LibsModule } from './libs/libs.module';
import { SharedModule } from './shared/shared.module';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { FormDirective } from './directives/form.directive';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PrimengcomponentsModule } from '@app/primengcomponents/primengcomponents.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgIdleKeepaliveModule } from '@ng-idle/keepalive'; // this includes the core NgIdleModule but includes keepalive providers for easy wireup

export function HttpLoaderFactory( http: HttpClient ) {
  return new TranslateHttpLoader( http );
}

@NgModule( {
  declarations: [
    AppComponent,
    FormDirective,
  ],
  imports: [
    TranslateModule.forRoot( {
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [ HttpClient ]
      }
    } ),
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    AuthRoutingModule,
    AuthModule,
    LibsModule,
    OfflineDatabaseModule,
    SharedModule,
    PrimengcomponentsModule,
    BrowserAnimationsModule,
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    Title,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
  ],
  bootstrap: [ AppComponent ]
} )
export class AppModule {
}
